import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=1b8cf9a6&scoped=true"
import script from "./terms.vue?vue&type=script&lang=js"
export * from "./terms.vue?vue&type=script&lang=js"
import style0 from "./terms.vue?vue&type=style&index=0&id=1b8cf9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8cf9a6",
  null
  
)

export default component.exports